// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Subscribe-by-admin modal — matches dashboard teal theme, lightweight for smooth UI */

.staking-subscribe-overlay {
  position: fixed;
  inset: 0;
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(15, 23, 42, 0.45);
}

.staking-subscribe-modal {
  position: relative;
  width: 100%;
  max-width: 640px;
  max-height: min(92vh, calc(100dvh - 2rem), 880px);
  display: flex;
  flex-direction: column;
  border-radius: 18px;
  overflow: hidden;
  background: #fff;
  box-shadow:
    0 25px 60px -15px rgba(15, 23, 42, 0.35),
    0 0 0 1px rgba(15, 118, 110, 0.12);
  border: 1px solid rgba(226, 232, 240, 0.95);
}

.staking-subscribe-modal form {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.staking-subscribe-modal__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.35rem 1.5rem 1.15rem;
  background: linear-gradient(125deg, #0f766e 0%, #0d9488 42%, #0f4c46 100%);
  color: #fff;
  gap: 1rem;
  flex-shrink: 0;
}

.staking-subscribe-modal__head-main {
  min-width: 0;
}

.staking-subscribe-modal__badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.82);
  margin-bottom: 0.35rem;
}

.staking-subscribe-modal__badge i {
  font-size: 0.72rem;
  opacity: 0.95;
}

.staking-subscribe-modal__head h2 {
  margin: 0 0 0.35rem;
  font-size: 1.28rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: #fff;
}

.staking-subscribe-modal__tagline {
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.78);
  max-width: 28rem;
}

.staking-subscribe-modal__close {
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  transition: background 0.15s;
}

.staking-subscribe-modal__close:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.22);
}

.staking-subscribe-modal__close:active:not(:disabled) {
  opacity: 0.92;
}

.staking-subscribe-modal__close:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.staking-subscribe-steps {
  display: flex;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.staking-subscribe-step {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.45rem;
  border-radius: 8px;
  font-size: 0.69rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
  border: 1px solid transparent;
}

.staking-subscribe-step-num {
  width: 22px;
  height: 22px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  font-weight: 800;
  background: rgba(148, 163, 184, 0.2);
  color: #64748b;
}

.staking-subscribe-step--active {
  color: #0f172a;
  background: rgba(15, 118, 110, 0.08);
  border-color: rgba(15, 118, 110, 0.2);
}

.staking-subscribe-step--active .staking-subscribe-step-num {
  background: linear-gradient(135deg, #0f766e, #14b8a6);
  color: #fff;
}

.staking-subscribe-step--done {
  color: #0f766e;
}

.staking-subscribe-step--done .staking-subscribe-step-num {
  background: rgba(15, 118, 110, 0.14);
  color: #0f766e;
}

.staking-subscribe-modal__scroll {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1.35rem 1.5rem 1rem;
  background: linear-gradient(180deg, #ecfdf5 0%, #f8fafc 38%, #f8fafc 100%);
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
}

.staking-subscribe-modal__layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

@media (min-width: 600px) {
  .staking-subscribe-modal__layout {
    grid-template-columns: minmax(0, 1fr) minmax(0, 200px);
    align-items: start;
    gap: 1.2rem;
  }
}

.staking-subscribe-modal__fields {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.staking-subscribe-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.staking-subscribe-field--user-search {
  position: relative;
  z-index: 2;
}

.staking-subscribe-user-suggestions {
  position: absolute;
  top: calc(100% - 2px);
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  max-height: 220px;
  overflow-y: auto;
  z-index: 20;
}

.staking-subscribe-user-suggest-item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 0.65rem 0.85rem;
  border: none;
  border-bottom: 1px solid #f1f5f9;
  background: #fff;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s;
}

.staking-subscribe-user-suggest-item:last-child {
  border-bottom: none;
}

button.staking-subscribe-user-suggest-item:hover {
  background: #f0fdfa;
}

.staking-subscribe-user-suggest-item--muted {
  color: #64748b;
  font-size: 0.85rem;
  cursor: default;
}

.staking-subscribe-user-suggest-item--muted:hover {
  background: #fff;
}

.staking-subscribe-user-suggest-item--error {
  color: #b91c1c;
  font-size: 0.82rem;
  cursor: default;
}

.staking-subscribe-user-suggest-item--error:hover {
  background: #fff;
}

.staking-subscribe-user-suggest__name {
  display: block;
  font-weight: 700;
  font-size: 0.88rem;
  color: #0f172a;
  margin-bottom: 0.15rem;
}

.staking-subscribe-user-suggest__line {
  display: block;
  font-size: 0.82rem;
  color: #334155;
  line-height: 1.35;
}

.staking-subscribe-user-suggest__uuid {
  color: #64748b;
  font-weight: 600;
}

.staking-subscribe-user-suggest__meta {
  display: block;
  font-size: 0.75rem;
  color: #64748b;
  margin-top: 0.2rem;
}

.staking-subscribe-field__hint--selected {
  color: #047857;
  font-weight: 600;
}

.staking-subscribe-field__label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.67rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #475569;
}

.staking-subscribe-field__label i {
  width: 1.2rem;
  text-align: center;
  color: #0f766e;
}

.staking-subscribe-field__control {
  font-family: inherit;
  font-size: 0.9rem;
  width: 100%;
  padding: 0.6rem 0.8rem;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #0f172a;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.staking-subscribe-field__control:hover:not(:disabled) {
  border-color: #99f6e4;
}

.staking-subscribe-field__control:focus {
  outline: none;
  border-color: #0d9488;
  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.15);
}

.staking-subscribe-field__control:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  background: #f1f5f9;
}

.staking-subscribe-field__hint {
  margin: 0;
  font-size: 0.78rem;
  line-height: 1.35;
  color: #475569;
  padding: 0.5rem 0.65rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(15, 118, 110, 0.12);
}

.staking-subscribe-alert {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  font-size: 0.875rem;
  line-height: 1.45;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
}

.staking-subscribe-loading {
  text-align: center;
  padding: 2.5rem 1.5rem;
  color: #64748b;
}

.staking-subscribe-loading__orbit {
  width: 38px;
  height: 38px;
  margin: 0 auto 0.85rem;
  border-radius: 50%;
  border: 3px solid #ccfbf1;
  border-top-color: #0f766e;
  animation: staking-subscribe-spin 0.65s linear infinite;
}

@keyframes staking-subscribe-spin {
  to {
    transform: rotate(360deg);
  }
}

.staking-subscribe-loading p {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 500;
}

.staking-subscribe-summary {
  border-radius: 14px;
  padding: 1rem;
  background: #fff;
  border: 1px solid rgba(226, 232, 240, 0.95);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 8px 24px rgba(15, 118, 110, 0.08);
}

.staking-subscribe-summary--empty {
  opacity: 0.92;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.staking-subscribe-summary__title {
  margin: 0 0 0.75rem;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #0f766e;
}

.staking-subscribe-summary__coin {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.9rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #f1f5f9;
}

.staking-subscribe-summary__coin-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ecfdf5 0%, #ccfbf1 100%);
  color: #0f766e;
  font-size: 1rem;
}

.staking-subscribe-summary__coin-text strong {
  display: block;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.staking-subscribe-summary__coin-text span {
  font-size: 0.74rem;
  color: #64748b;
}

.staking-subscribe-summary__dl {
  margin: 0;
  display: grid;
  gap: 0.55rem;
}

.staking-subscribe-summary__dl dt {
  margin: 0;
  font-size: 0.6rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #94a3b8;
}

.staking-subscribe-summary__dl dd {
  margin: 0.08rem 0 0;
  font-size: 0.86rem;
  font-weight: 600;
  color: #334155;
}

.staking-subscribe-zil-convert {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px dashed #99f6e4;
}

.staking-subscribe-zil-convert__title {
  margin: 0 0 0.35rem;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0f766e;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.staking-subscribe-zil-convert__sub {
  margin: 0 0 0.75rem;
  font-size: 0.72rem;
  color: #64748b;
  line-height: 1.45;
}

.staking-subscribe-zil-convert__field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-bottom: 0.55rem;
}

.staking-subscribe-zil-convert__field span {
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
}

.staking-subscribe-zil-convert__field input {
  width: 100%;
  padding: 0.55rem 0.65rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.88rem;
  font-family: inherit;
  color: #0f172a;
  background: #f8fafc;
  box-sizing: border-box;
}

.staking-subscribe-zil-convert__field input:focus {
  outline: none;
  border-color: #0f766e;
  background: #fff;
}

.staking-subscribe-zil-convert__btn {
  width: 100%;
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  border: 1px solid rgba(15, 118, 110, 0.4);
  background: linear-gradient(180deg, #fff 0%, #ecfdf5 100%);
  color: #0f766e;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  transition: background 0.2s, border-color 0.2s;
}

.staking-subscribe-zil-convert__btn:hover:not(:disabled) {
  background: #ccfbf1;
  border-color: #0d9488;
}

.staking-subscribe-zil-convert__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.staking-subscribe-zil-convert__error {
  margin: 0.5rem 0 0;
  font-size: 0.75rem;
  color: #b91c1c;
  line-height: 1.4;
}

.staking-subscribe-zil-convert__result {
  margin-top: 0.65rem;
  padding: 0.65rem 0.75rem;
  border-radius: 10px;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border: 1px solid #6ee7b7;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.staking-subscribe-zil-convert__result-label {
  font-size: 0.6rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #047857;
}

.staking-subscribe-zil-convert__result strong {
  font-size: 1.05rem;
  color: #065f46;
  font-variant-numeric: tabular-nums;
}

.staking-subscribe-zil-convert__result-meta {
  font-size: 0.72rem;
  color: #64748b;
}

.staking-subscribe-zil-convert__apply {
  margin-top: 0.35rem;
  align-self: flex-start;
  font-family: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 0.35rem 0.65rem;
  border-radius: 6px;
  border: none;
  background: #0f766e;
  color: #fff;
  cursor: pointer;
  transition: background 0.2s;
}

.staking-subscribe-zil-convert__apply:hover {
  background: #0d9488;
}

/* —— Verify / review step —— */
.staking-subscribe-review {
  padding: 0.25rem 0;
}

.staking-subscribe-review__intro {
  margin: 0 0 1rem;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  background: linear-gradient(135deg, #ecfdf5 0%, #f0fdfa 100%);
  border: 1px solid #99f6e4;
  font-size: 0.88rem;
  color: #0f4c46;
  line-height: 1.45;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.staking-subscribe-review__intro i {
  margin-top: 0.15rem;
  color: #0f766e;
}

.staking-subscribe-review__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
}

@media (max-width: 640px) {
  .staking-subscribe-review__grid {
    grid-template-columns: 1fr;
  }
}

.staking-subscribe-review__card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem 1.1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.staking-subscribe-review__card h3 {
  margin: 0 0 0.75rem;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #0f766e;
}

.staking-subscribe-review__card dl {
  margin: 0;
  display: grid;
  gap: 0.6rem;
}

.staking-subscribe-review__card dt {
  margin: 0;
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
}

.staking-subscribe-review__card dd {
  margin: 0.12rem 0 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.35;
  word-break: break-word;
}

.staking-subscribe-review__mono {
  font-size: 0.78rem !important;
  font-family: ui-monospace, monospace;
  opacity: 0.9;
}

.staking-subscribe-review__highlight {
  font-size: 1.05rem !important;
  color: #047857 !important;
  font-weight: 800 !important;
}

.staking-subscribe-review__sub {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: #64748b;
  line-height: 1.4;
}

.staking-subscribe-modal__foot {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.95rem 1.5rem 1.1rem;
  background: #fff;
  border-top: 1px solid #e2e8f0;
}

.staking-subscribe-btn-ghost {
  font-family: inherit;
  font-size: 0.87rem;
  font-weight: 600;
  padding: 0.55rem 1.1rem;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
  cursor: pointer;
  transition: background 0.15s;
}

.staking-subscribe-btn-ghost:hover:not(:disabled) {
  background: #f1f5f9;
}

.staking-subscribe-btn-ghost:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.staking-subscribe-btn-primary {
  font-family: inherit;
  font-size: 0.88rem;
  font-weight: 700;
  padding: 0.55rem 1.25rem;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.35);
  transition: opacity 0.15s;
}

.staking-subscribe-btn-primary:hover:not(:disabled) {
  opacity: 0.95;
}

.staking-subscribe-btn-primary:active:not(:disabled) {
  opacity: 0.88;
}

.staking-subscribe-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 640px) {
  .staking-subscribe-overlay {
    align-items: flex-start;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0.75rem;
  }

  .staking-subscribe-modal {
    max-height: calc(100dvh - 1.5rem);
    margin: auto 0;
    flex-shrink: 0;
  }

  .staking-subscribe-modal__head {
    padding: 1rem 1.1rem 0.9rem;
  }

  .staking-subscribe-modal__head h2 {
    font-size: 1.1rem;
  }

  .staking-subscribe-steps {
    padding: 0.6rem 0.75rem;
    gap: 0.35rem;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    flex-shrink: 0;
  }

  .staking-subscribe-step {
    flex: 0 0 auto;
    min-width: 4.5rem;
    font-size: 0.62rem;
  }

  .staking-subscribe-modal__scroll {
    padding: 1rem 1.1rem 0.85rem;
  }

  .staking-subscribe-modal__foot {
    flex-wrap: wrap;
    justify-content: stretch;
    padding: 0.85rem 1.1rem 1rem;
    gap: 0.45rem;
  }

  .staking-subscribe-modal__foot .staking-subscribe-btn-ghost,
  .staking-subscribe-modal__foot .staking-subscribe-btn-primary {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 0.25rem);
    min-width: 0;
    justify-content: center;
  }
}

/* —— Existing-stake check banner —— */
.staking-subscribe-stake-check {
  border-radius: 10px;
  padding: 0.75rem 0.9rem;
  font-size: 0.84rem;
  line-height: 1.5;
  border: 1px solid transparent;
}

.staking-subscribe-stake-check--loading {
  background: #f8fafc;
  border-color: #e2e8f0;
  color: #64748b;
}

.staking-subscribe-stake-check__loading {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.82rem;
  color: #64748b;
}

.staking-subscribe-stake-check--warn {
  background: #fffbeb;
  border-color: #fcd34d;
}

.staking-subscribe-stake-check--ok {
  background: #f0fdf4;
  border-color: #86efac;
}

.staking-subscribe-stake-check__head {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  color: #92400e;
  font-weight: 700;
  margin-bottom: 0.6rem;
}

.staking-subscribe-stake-check__head i {
  color: #d97706;
  font-size: 0.9rem;
  margin-top: 0.1rem;
  flex-shrink: 0;
}

.staking-subscribe-stake-check__details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.4rem 0.75rem;
  margin-bottom: 0.6rem;
}

.staking-subscribe-stake-check__details > span {
  display: flex;
  flex-direction: column;
  gap: 0.05rem;
}

.staking-subscribe-stake-check__key {
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #b45309;
}

.staking-subscribe-stake-check__val {
  font-size: 0.84rem;
  font-weight: 700;
  color: #78350f;
}

.staking-subscribe-stake-check__note {
  margin: 0;
  font-size: 0.75rem;
  color: #92400e;
  opacity: 0.85;
  font-style: italic;
}

.staking-subscribe-stake-check__ok-msg {
  margin: 0;
  color: #166534;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.84rem;
}

.staking-subscribe-stake-check__ok-msg i {
  color: #16a34a;
}

/* —— Reinvest confirm modal —— */
.staking-reinvest-confirm {
  background: #fff;
  border-radius: 16px;
  max-width: 420px;
  width: 100%;
  overflow: hidden;
  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.4);
  border: 1px solid rgba(226, 232, 240, 0.95);
}

.staking-reinvest-confirm__head {
  padding: 1.25rem 1.35rem 1rem;
  background: linear-gradient(125deg, #92400e 0%, #d97706 55%, #78350f 100%);
  color: #fff;
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.staking-reinvest-confirm__head i {
  font-size: 1.35rem;
  opacity: 0.9;
  flex-shrink: 0;
}

.staking-reinvest-confirm__head h2 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.02em;
}

.staking-reinvest-confirm__body {
  padding: 1.1rem 1.35rem;
}

.staking-reinvest-confirm__msg {
  margin: 0 0 0.85rem;
  font-size: 0.88rem;
  color: #334155;
  line-height: 1.5;
}

.staking-reinvest-confirm__existing {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem 0.75rem;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-radius: 10px;
  padding: 0.75rem 0.9rem;
  margin-bottom: 0.85rem;
}

.staking-reinvest-confirm__existing > div {
  display: flex;
  flex-direction: column;
  gap: 0.08rem;
}

.staking-reinvest-confirm__existing span {
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #b45309;
}

.staking-reinvest-confirm__existing strong {
  font-size: 0.85rem;
  color: #78350f;
}

.staking-reinvest-confirm__question {
  margin: 0;
  font-size: 0.86rem;
  color: #475569;
  line-height: 1.5;
}

.staking-reinvest-confirm__foot {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0 1.35rem 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Staking/StakingSubscribeByAdmin.css"],"names":[],"mappings":"AAAA,uFAAuF;;AAEvF;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB;;sCAEoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,0EAA0E;EAC1E,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,0CAA0C;EAC1C,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,0EAA0E;EAC1E,iCAAiC;EACjC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,sDAAsD;IACtD,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,uDAAuD;AACzD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,2CAA2C;EAC3C,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,0DAA0D;EAC1D,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,6DAA6D;EAC7D,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;IACjC,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,iCAAiC;IACjC,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,4BAA4B;IAC5B,YAAY;EACd;;EAEA;;IAEE,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;IAC7B,YAAY;IACZ,uBAAuB;EACzB;AACF;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mDAAmD;EACnD,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,0EAA0E;EAC1E,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,0BAA0B;AAC5B","sourcesContent":["/* Subscribe-by-admin modal — matches dashboard teal theme, lightweight for smooth UI */\n\n.staking-subscribe-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1060;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(15, 23, 42, 0.45);\n}\n\n.staking-subscribe-modal {\n  position: relative;\n  width: 100%;\n  max-width: 640px;\n  max-height: min(92vh, calc(100dvh - 2rem), 880px);\n  display: flex;\n  flex-direction: column;\n  border-radius: 18px;\n  overflow: hidden;\n  background: #fff;\n  box-shadow:\n    0 25px 60px -15px rgba(15, 23, 42, 0.35),\n    0 0 0 1px rgba(15, 118, 110, 0.12);\n  border: 1px solid rgba(226, 232, 240, 0.95);\n}\n\n.staking-subscribe-modal form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.staking-subscribe-modal__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1.35rem 1.5rem 1.15rem;\n  background: linear-gradient(125deg, #0f766e 0%, #0d9488 42%, #0f4c46 100%);\n  color: #fff;\n  gap: 1rem;\n  flex-shrink: 0;\n}\n\n.staking-subscribe-modal__head-main {\n  min-width: 0;\n}\n\n.staking-subscribe-modal__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.82);\n  margin-bottom: 0.35rem;\n}\n\n.staking-subscribe-modal__badge i {\n  font-size: 0.72rem;\n  opacity: 0.95;\n}\n\n.staking-subscribe-modal__head h2 {\n  margin: 0 0 0.35rem;\n  font-size: 1.28rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: #fff;\n}\n\n.staking-subscribe-modal__tagline {\n  margin: 0;\n  font-size: 0.82rem;\n  line-height: 1.45;\n  color: rgba(255, 255, 255, 0.78);\n  max-width: 28rem;\n}\n\n.staking-subscribe-modal__close {\n  flex-shrink: 0;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #fff;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  transition: background 0.15s;\n}\n\n.staking-subscribe-modal__close:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.22);\n}\n\n.staking-subscribe-modal__close:active:not(:disabled) {\n  opacity: 0.92;\n}\n\n.staking-subscribe-modal__close:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.staking-subscribe-steps {\n  display: flex;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  flex-shrink: 0;\n}\n\n.staking-subscribe-step {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.4rem 0.45rem;\n  border-radius: 8px;\n  font-size: 0.69rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #94a3b8;\n  border: 1px solid transparent;\n}\n\n.staking-subscribe-step-num {\n  width: 22px;\n  height: 22px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.65rem;\n  font-weight: 800;\n  background: rgba(148, 163, 184, 0.2);\n  color: #64748b;\n}\n\n.staking-subscribe-step--active {\n  color: #0f172a;\n  background: rgba(15, 118, 110, 0.08);\n  border-color: rgba(15, 118, 110, 0.2);\n}\n\n.staking-subscribe-step--active .staking-subscribe-step-num {\n  background: linear-gradient(135deg, #0f766e, #14b8a6);\n  color: #fff;\n}\n\n.staking-subscribe-step--done {\n  color: #0f766e;\n}\n\n.staking-subscribe-step--done .staking-subscribe-step-num {\n  background: rgba(15, 118, 110, 0.14);\n  color: #0f766e;\n}\n\n.staking-subscribe-modal__scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 1.35rem 1.5rem 1rem;\n  background: linear-gradient(180deg, #ecfdf5 0%, #f8fafc 38%, #f8fafc 100%);\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  touch-action: pan-y;\n}\n\n.staking-subscribe-modal__layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n}\n\n@media (min-width: 600px) {\n  .staking-subscribe-modal__layout {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 200px);\n    align-items: start;\n    gap: 1.2rem;\n  }\n}\n\n.staking-subscribe-modal__fields {\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n}\n\n.staking-subscribe-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.staking-subscribe-field--user-search {\n  position: relative;\n  z-index: 2;\n}\n\n.staking-subscribe-user-suggestions {\n  position: absolute;\n  top: calc(100% - 2px);\n  left: 0;\n  right: 0;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n  max-height: 220px;\n  overflow-y: auto;\n  z-index: 20;\n}\n\n.staking-subscribe-user-suggest-item {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 0.65rem 0.85rem;\n  border: none;\n  border-bottom: 1px solid #f1f5f9;\n  background: #fff;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.15s;\n}\n\n.staking-subscribe-user-suggest-item:last-child {\n  border-bottom: none;\n}\n\nbutton.staking-subscribe-user-suggest-item:hover {\n  background: #f0fdfa;\n}\n\n.staking-subscribe-user-suggest-item--muted {\n  color: #64748b;\n  font-size: 0.85rem;\n  cursor: default;\n}\n\n.staking-subscribe-user-suggest-item--muted:hover {\n  background: #fff;\n}\n\n.staking-subscribe-user-suggest-item--error {\n  color: #b91c1c;\n  font-size: 0.82rem;\n  cursor: default;\n}\n\n.staking-subscribe-user-suggest-item--error:hover {\n  background: #fff;\n}\n\n.staking-subscribe-user-suggest__name {\n  display: block;\n  font-weight: 700;\n  font-size: 0.88rem;\n  color: #0f172a;\n  margin-bottom: 0.15rem;\n}\n\n.staking-subscribe-user-suggest__line {\n  display: block;\n  font-size: 0.82rem;\n  color: #334155;\n  line-height: 1.35;\n}\n\n.staking-subscribe-user-suggest__uuid {\n  color: #64748b;\n  font-weight: 600;\n}\n\n.staking-subscribe-user-suggest__meta {\n  display: block;\n  font-size: 0.75rem;\n  color: #64748b;\n  margin-top: 0.2rem;\n}\n\n.staking-subscribe-field__hint--selected {\n  color: #047857;\n  font-weight: 600;\n}\n\n.staking-subscribe-field__label {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.67rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: #475569;\n}\n\n.staking-subscribe-field__label i {\n  width: 1.2rem;\n  text-align: center;\n  color: #0f766e;\n}\n\n.staking-subscribe-field__control {\n  font-family: inherit;\n  font-size: 0.9rem;\n  width: 100%;\n  padding: 0.6rem 0.8rem;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #0f172a;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.staking-subscribe-field__control:hover:not(:disabled) {\n  border-color: #99f6e4;\n}\n\n.staking-subscribe-field__control:focus {\n  outline: none;\n  border-color: #0d9488;\n  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.15);\n}\n\n.staking-subscribe-field__control:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  background: #f1f5f9;\n}\n\n.staking-subscribe-field__hint {\n  margin: 0;\n  font-size: 0.78rem;\n  line-height: 1.35;\n  color: #475569;\n  padding: 0.5rem 0.65rem;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(15, 118, 110, 0.12);\n}\n\n.staking-subscribe-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  font-size: 0.875rem;\n  line-height: 1.45;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #b91c1c;\n}\n\n.staking-subscribe-loading {\n  text-align: center;\n  padding: 2.5rem 1.5rem;\n  color: #64748b;\n}\n\n.staking-subscribe-loading__orbit {\n  width: 38px;\n  height: 38px;\n  margin: 0 auto 0.85rem;\n  border-radius: 50%;\n  border: 3px solid #ccfbf1;\n  border-top-color: #0f766e;\n  animation: staking-subscribe-spin 0.65s linear infinite;\n}\n\n@keyframes staking-subscribe-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.staking-subscribe-loading p {\n  margin: 0;\n  font-size: 0.88rem;\n  font-weight: 500;\n}\n\n.staking-subscribe-summary {\n  border-radius: 14px;\n  padding: 1rem;\n  background: #fff;\n  border: 1px solid rgba(226, 232, 240, 0.95);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 8px 24px rgba(15, 118, 110, 0.08);\n}\n\n.staking-subscribe-summary--empty {\n  opacity: 0.92;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.staking-subscribe-summary__title {\n  margin: 0 0 0.75rem;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #0f766e;\n}\n\n.staking-subscribe-summary__coin {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  margin-bottom: 0.9rem;\n  padding-bottom: 0.85rem;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.staking-subscribe-summary__coin-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #ecfdf5 0%, #ccfbf1 100%);\n  color: #0f766e;\n  font-size: 1rem;\n}\n\n.staking-subscribe-summary__coin-text strong {\n  display: block;\n  font-size: 1rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.staking-subscribe-summary__coin-text span {\n  font-size: 0.74rem;\n  color: #64748b;\n}\n\n.staking-subscribe-summary__dl {\n  margin: 0;\n  display: grid;\n  gap: 0.55rem;\n}\n\n.staking-subscribe-summary__dl dt {\n  margin: 0;\n  font-size: 0.6rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #94a3b8;\n}\n\n.staking-subscribe-summary__dl dd {\n  margin: 0.08rem 0 0;\n  font-size: 0.86rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n.staking-subscribe-zil-convert {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px dashed #99f6e4;\n}\n\n.staking-subscribe-zil-convert__title {\n  margin: 0 0 0.35rem;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.staking-subscribe-zil-convert__sub {\n  margin: 0 0 0.75rem;\n  font-size: 0.72rem;\n  color: #64748b;\n  line-height: 1.45;\n}\n\n.staking-subscribe-zil-convert__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  margin-bottom: 0.55rem;\n}\n\n.staking-subscribe-zil-convert__field span {\n  font-size: 0.62rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #94a3b8;\n}\n\n.staking-subscribe-zil-convert__field input {\n  width: 100%;\n  padding: 0.55rem 0.65rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.88rem;\n  font-family: inherit;\n  color: #0f172a;\n  background: #f8fafc;\n  box-sizing: border-box;\n}\n\n.staking-subscribe-zil-convert__field input:focus {\n  outline: none;\n  border-color: #0f766e;\n  background: #fff;\n}\n\n.staking-subscribe-zil-convert__btn {\n  width: 100%;\n  font-family: inherit;\n  font-size: 0.8rem;\n  font-weight: 700;\n  padding: 0.5rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid rgba(15, 118, 110, 0.4);\n  background: linear-gradient(180deg, #fff 0%, #ecfdf5 100%);\n  color: #0f766e;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.staking-subscribe-zil-convert__btn:hover:not(:disabled) {\n  background: #ccfbf1;\n  border-color: #0d9488;\n}\n\n.staking-subscribe-zil-convert__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.staking-subscribe-zil-convert__error {\n  margin: 0.5rem 0 0;\n  font-size: 0.75rem;\n  color: #b91c1c;\n  line-height: 1.4;\n}\n\n.staking-subscribe-zil-convert__result {\n  margin-top: 0.65rem;\n  padding: 0.65rem 0.75rem;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);\n  border: 1px solid #6ee7b7;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.staking-subscribe-zil-convert__result-label {\n  font-size: 0.6rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #047857;\n}\n\n.staking-subscribe-zil-convert__result strong {\n  font-size: 1.05rem;\n  color: #065f46;\n  font-variant-numeric: tabular-nums;\n}\n\n.staking-subscribe-zil-convert__result-meta {\n  font-size: 0.72rem;\n  color: #64748b;\n}\n\n.staking-subscribe-zil-convert__apply {\n  margin-top: 0.35rem;\n  align-self: flex-start;\n  font-family: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 0.35rem 0.65rem;\n  border-radius: 6px;\n  border: none;\n  background: #0f766e;\n  color: #fff;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.staking-subscribe-zil-convert__apply:hover {\n  background: #0d9488;\n}\n\n/* —— Verify / review step —— */\n.staking-subscribe-review {\n  padding: 0.25rem 0;\n}\n\n.staking-subscribe-review__intro {\n  margin: 0 0 1rem;\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #ecfdf5 0%, #f0fdfa 100%);\n  border: 1px solid #99f6e4;\n  font-size: 0.88rem;\n  color: #0f4c46;\n  line-height: 1.45;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.staking-subscribe-review__intro i {\n  margin-top: 0.15rem;\n  color: #0f766e;\n}\n\n.staking-subscribe-review__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.85rem;\n}\n\n@media (max-width: 640px) {\n  .staking-subscribe-review__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.staking-subscribe-review__card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1rem 1.1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.staking-subscribe-review__card h3 {\n  margin: 0 0 0.75rem;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #0f766e;\n}\n\n.staking-subscribe-review__card dl {\n  margin: 0;\n  display: grid;\n  gap: 0.6rem;\n}\n\n.staking-subscribe-review__card dt {\n  margin: 0;\n  font-size: 0.62rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #94a3b8;\n}\n\n.staking-subscribe-review__card dd {\n  margin: 0.12rem 0 0;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #0f172a;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.staking-subscribe-review__mono {\n  font-size: 0.78rem !important;\n  font-family: ui-monospace, monospace;\n  opacity: 0.9;\n}\n\n.staking-subscribe-review__highlight {\n  font-size: 1.05rem !important;\n  color: #047857 !important;\n  font-weight: 800 !important;\n}\n\n.staking-subscribe-review__sub {\n  display: block;\n  margin-top: 0.25rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n.staking-subscribe-modal__foot {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  padding: 0.95rem 1.5rem 1.1rem;\n  background: #fff;\n  border-top: 1px solid #e2e8f0;\n}\n\n.staking-subscribe-btn-ghost {\n  font-family: inherit;\n  font-size: 0.87rem;\n  font-weight: 600;\n  padding: 0.55rem 1.1rem;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #475569;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.staking-subscribe-btn-ghost:hover:not(:disabled) {\n  background: #f1f5f9;\n}\n\n.staking-subscribe-btn-ghost:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.staking-subscribe-btn-primary {\n  font-family: inherit;\n  font-size: 0.88rem;\n  font-weight: 700;\n  padding: 0.55rem 1.25rem;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.35);\n  transition: opacity 0.15s;\n}\n\n.staking-subscribe-btn-primary:hover:not(:disabled) {\n  opacity: 0.95;\n}\n\n.staking-subscribe-btn-primary:active:not(:disabled) {\n  opacity: 0.88;\n}\n\n.staking-subscribe-btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n@media (max-width: 640px) {\n  .staking-subscribe-overlay {\n    align-items: flex-start;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    padding: 0.75rem;\n  }\n\n  .staking-subscribe-modal {\n    max-height: calc(100dvh - 1.5rem);\n    margin: auto 0;\n    flex-shrink: 0;\n  }\n\n  .staking-subscribe-modal__head {\n    padding: 1rem 1.1rem 0.9rem;\n  }\n\n  .staking-subscribe-modal__head h2 {\n    font-size: 1.1rem;\n  }\n\n  .staking-subscribe-steps {\n    padding: 0.6rem 0.75rem;\n    gap: 0.35rem;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    flex-shrink: 0;\n  }\n\n  .staking-subscribe-step {\n    flex: 0 0 auto;\n    min-width: 4.5rem;\n    font-size: 0.62rem;\n  }\n\n  .staking-subscribe-modal__scroll {\n    padding: 1rem 1.1rem 0.85rem;\n  }\n\n  .staking-subscribe-modal__foot {\n    flex-wrap: wrap;\n    justify-content: stretch;\n    padding: 0.85rem 1.1rem 1rem;\n    gap: 0.45rem;\n  }\n\n  .staking-subscribe-modal__foot .staking-subscribe-btn-ghost,\n  .staking-subscribe-modal__foot .staking-subscribe-btn-primary {\n    flex: 1 1 calc(50% - 0.25rem);\n    min-width: 0;\n    justify-content: center;\n  }\n}\n\n/* —— Existing-stake check banner —— */\n.staking-subscribe-stake-check {\n  border-radius: 10px;\n  padding: 0.75rem 0.9rem;\n  font-size: 0.84rem;\n  line-height: 1.5;\n  border: 1px solid transparent;\n}\n\n.staking-subscribe-stake-check--loading {\n  background: #f8fafc;\n  border-color: #e2e8f0;\n  color: #64748b;\n}\n\n.staking-subscribe-stake-check__loading {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.82rem;\n  color: #64748b;\n}\n\n.staking-subscribe-stake-check--warn {\n  background: #fffbeb;\n  border-color: #fcd34d;\n}\n\n.staking-subscribe-stake-check--ok {\n  background: #f0fdf4;\n  border-color: #86efac;\n}\n\n.staking-subscribe-stake-check__head {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  color: #92400e;\n  font-weight: 700;\n  margin-bottom: 0.6rem;\n}\n\n.staking-subscribe-stake-check__head i {\n  color: #d97706;\n  font-size: 0.9rem;\n  margin-top: 0.1rem;\n  flex-shrink: 0;\n}\n\n.staking-subscribe-stake-check__details {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.4rem 0.75rem;\n  margin-bottom: 0.6rem;\n}\n\n.staking-subscribe-stake-check__details > span {\n  display: flex;\n  flex-direction: column;\n  gap: 0.05rem;\n}\n\n.staking-subscribe-stake-check__key {\n  font-size: 0.62rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #b45309;\n}\n\n.staking-subscribe-stake-check__val {\n  font-size: 0.84rem;\n  font-weight: 700;\n  color: #78350f;\n}\n\n.staking-subscribe-stake-check__note {\n  margin: 0;\n  font-size: 0.75rem;\n  color: #92400e;\n  opacity: 0.85;\n  font-style: italic;\n}\n\n.staking-subscribe-stake-check__ok-msg {\n  margin: 0;\n  color: #166534;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-size: 0.84rem;\n}\n\n.staking-subscribe-stake-check__ok-msg i {\n  color: #16a34a;\n}\n\n/* —— Reinvest confirm modal —— */\n.staking-reinvest-confirm {\n  background: #fff;\n  border-radius: 16px;\n  max-width: 420px;\n  width: 100%;\n  overflow: hidden;\n  box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.4);\n  border: 1px solid rgba(226, 232, 240, 0.95);\n}\n\n.staking-reinvest-confirm__head {\n  padding: 1.25rem 1.35rem 1rem;\n  background: linear-gradient(125deg, #92400e 0%, #d97706 55%, #78350f 100%);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.staking-reinvest-confirm__head i {\n  font-size: 1.35rem;\n  opacity: 0.9;\n  flex-shrink: 0;\n}\n\n.staking-reinvest-confirm__head h2 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 800;\n  color: #fff;\n  letter-spacing: -0.02em;\n}\n\n.staking-reinvest-confirm__body {\n  padding: 1.1rem 1.35rem;\n}\n\n.staking-reinvest-confirm__msg {\n  margin: 0 0 0.85rem;\n  font-size: 0.88rem;\n  color: #334155;\n  line-height: 1.5;\n}\n\n.staking-reinvest-confirm__existing {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.5rem 0.75rem;\n  background: #fffbeb;\n  border: 1px solid #fcd34d;\n  border-radius: 10px;\n  padding: 0.75rem 0.9rem;\n  margin-bottom: 0.85rem;\n}\n\n.staking-reinvest-confirm__existing > div {\n  display: flex;\n  flex-direction: column;\n  gap: 0.08rem;\n}\n\n.staking-reinvest-confirm__existing span {\n  font-size: 0.62rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #b45309;\n}\n\n.staking-reinvest-confirm__existing strong {\n  font-size: 0.85rem;\n  color: #78350f;\n}\n\n.staking-reinvest-confirm__question {\n  margin: 0;\n  font-size: 0.86rem;\n  color: #475569;\n  line-height: 1.5;\n}\n\n.staking-reinvest-confirm__foot {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  padding: 0 1.35rem 1.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
